/* Inéa V4 — panier latéral.
   - S'ouvre après un ajout au panier (événement « iv4:cart-added ») et au clic sur l'icône du panier.
   - Le contenu est rendu par Shopify (section iv4-cart-drawer) et rechargé par l'API Section Rendering.
   - Quantités et suppression via /cart/change.js (clé de ligne), le paiement reste le checkout natif.
   - Accessibilité : dialogue modal, focus piégé, Échap, retour du focus, défilement de la page bloqué. */
(function () {
  var root = document.querySelector('[data-iv4-cd]');
  if (!root) return;
  var panel = root.querySelector('.cd-panel');
  var SECTION = 'iv4-cart-drawer';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var enabled = root.getAttribute('data-enabled') !== 'false';
  var lastFocus = null, busy = false, closeTimer = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function updateCount(n) {
    document.dispatchEvent(new CustomEvent('iv4:cart-updated', { detail: { item_count: n } }));
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-inner]');
    var cur = root.querySelector('[data-cd-inner]');
    if (!fresh || !cur) return;
    cur.replaceWith(fresh);
    updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
  }

  function refresh() {
    return fetch(base + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[SECTION]) swap(data[SECTION]); });
  }

  function status(msg) {
    var s = root.querySelector('[data-cd-status]');
    if (s) s.textContent = msg || '';
  }

  function open() {
    if (!root.hidden && root.classList.contains('is-open')) return;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('iv4-cd-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    setTimeout(function () {
      var x = root.querySelector('.cd-x');
      try { (x || panel).focus({ preventScroll: true }); } catch (e) { (x || panel).focus(); }
    }, reduce ? 0 : 60);
  }

  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('iv4-cd-lock');
    closeTimer = setTimeout(function () { root.hidden = true; }, reduce ? 0 : 320);
    if (lastFocus && document.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
  }

  // Fermeture : fond, croix, « Continuer mes achats », Échap.
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-cd-qty]');
    if (!q || busy) return;
    var item = q.closest('[data-cd-key]');
    if (!item) return;
    var qty = parseInt(q.getAttribute('data-cd-qty'), 10);
    busy = true;
    item.classList.add('is-busy');
    fetch(base + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.getAttribute('data-cd-key'), quantity: qty, sections: [SECTION] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.d && (res.d.description || res.d.message)) || 'Modification impossible.');
        if (res.d.sections && res.d.sections[SECTION]) swap(res.d.sections[SECTION]);
        else return refresh();
      })
      .then(function () {
        status(qty === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
        var x = root.querySelector('.cd-x'); if (x && !panel.contains(document.activeElement)) x.focus();
      })
      .catch(function (err) {
        item.classList.remove('is-busy');
        status(err.message);
      })
      .then(function () { busy = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  if (!enabled) return;

  // Après un ajout au panier (configurateur de pack, produit simple).
  document.addEventListener('iv4:cart-added', function () {
    refresh().then(open, open);
  });

  // Icône du panier dans l'en-tête : ouvre le panier latéral au lieu de changer de page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-iv4-cart-link]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    refresh().then(open, open);
  });
})();
